import styled from 'styled-components';
import { Input as ANTDInput } from 'antd';

export const MainContainer = styled.div`
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const InputContainer = styled.div`
    padding: 10px 0px 0px 10px;
    border-radius: 8px;
    background-color: #e9ecf2;
    width: 100%;
    height: 42px;
    border: ${props => props.error ? "solid 1px #f10b3c" : "none"};

    label{
        font-size: 11px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 0;
        letter-spacing: normal;
        text-align: left;
        color: ${props => props.hasError ? "#f10b3c" : "#6b7384"};
        margin-bottom: 0px;
        display: block;
    }
`;

export const Input = styled(ANTDInput)`
    padding: 4px 4px 0px 0px;
`;

export const ErrorText = styled.div`
    color: #f10b3c;
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    padding: 2px 16px;
`;